import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-handle',
    imports: [],
    templateUrl: './handle.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './handle.component.scss'
})
export class HandleComponent {

}
